import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import { useDispatch } from 'react-redux';
import { setTicketEasySelectedStartModule } from '../../../../app/slices/TicketEasyModuleSlice';
import { ticketEasyColors } from '../../TicketEasyTheme';

const cards = [
  {
    id: 1,
    title: 'UAR',
    description: 'Request User Access.',
  },
  {
    id: 2,
    title: 'Applications',
    description: 'Report an issue with an Application.',
  },
  {
    id: 3,
    title: 'Reports',
    description: 'Request for modification of a report.',
  },
];

function TicketEasySelectModule(props: { onClick: () => void }) {
  const [selectedCard, setSelectedCard] = React.useState(0);
  const dispatch = useDispatch();
  return (
    <React.Fragment>
      <Box
        className="ticketEasy-module"
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          minHeight: '80vh',
          paddingTop: 4,
        }}
      >
        <Box
          sx={{
            width: '100%',
            maxWidth: 800,
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))',
            gap: 3,
          }}
        >
          {cards.map((card, index) => (
            <Card 
              key={card.id} 
              elevation={3}
              sx={{
                transition: 'transform 0.2s, box-shadow 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: 6
                }
              }}
            >
              <CardActionArea
                onClick={() => {
                  setSelectedCard(index);
                  dispatch(setTicketEasySelectedStartModule(card.title));
                  props.onClick();
                }}
                data-active={selectedCard === index ? '' : undefined}
                sx={{
                  height: '100%',
                  '&[data-active]': {
                    backgroundColor: `${ticketEasyColors.psnBackground}`,
                    '&:hover': {
                      backgroundColor: `${ticketEasyColors.psnBackground}`,
                    },
                  },
                }}
              >
                <CardContent sx={{ 
                  height: '100%',
                  padding: 3,
                  borderTop: `4px solid ${ticketEasyColors.psnGreen}`,
                }}>
                  <Typography 
                    variant="h5" 
                    component="div" 
                    sx={{ 
                      fontWeight: 600, 
                      mb: 2,
                      color: ticketEasyColors.psnBlue 
                    }}
                  >
                    {card.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    {card.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          ))}
        </Box>
      </Box>
    </React.Fragment>
  );
}

export { TicketEasySelectModule };
